import React from 'react';
import { Link } from 'react-router-dom';
import { blogArticles } from '../mockData';
import { Card, CardContent } from '../components/ui/card';
import { Button } from '../components/ui/button';
import { Clock, Calendar, ChevronRight } from 'lucide-react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import WhatsAppButton from '../components/WhatsAppButton';

const BlogPage = () => {
  return (
    <>
      <Header />
      <main className="pt-24 pb-16 bg-white dark:bg-slate-900">
        {/* Hero Section */}
        <section className="bg-gradient-to-r from-blue-600 to-blue-700 py-16">
          <div className="max-w-7xl mx-auto px-6 text-center">
            <h1 className="text-3xl md:text-4xl font-bold text-white mb-4">
              Health Articles & Tips
            </h1>
            <p className="text-xl text-blue-100 max-w-2xl mx-auto">
              Expert insights on respiratory health, prevention, and wellness from Dr. Akshay Kawedia
            </p>
          </div>
        </section>

        <section className="max-w-7xl mx-auto px-6 py-12">
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
            {blogArticles.map((article) => (
              <Card key={article.id} className="hover:shadow-lg transition-shadow overflow-hidden">
                <div className="h-48 overflow-hidden">
                  <img src={article.image} alt={article.title} className="w-full h-full object-cover hover:scale-105 transition-transform duration-300" />
                </div>
                <CardContent className="p-6">
                  <div className="flex items-center gap-4 text-sm text-gray-500 dark:text-slate-400 mb-3">
                    <span className="flex items-center gap-1"><Calendar className="w-4 h-4" />{article.date}</span>
                    <span className="flex items-center gap-1"><Clock className="w-4 h-4" />{article.readTime}</span>
                  </div>
                  <h3 className="text-xl font-bold text-gray-900 dark:text-slate-50 mb-2">{article.title}</h3>
                  <p className="text-gray-600 dark:text-slate-400 mb-4 line-clamp-2">{article.excerpt}</p>
                  <Link to={`/blog/${article.id}`}>
                    <Button variant="link" className="px-0 text-blue-600 dark:text-blue-400 group">
                      Read Article
                      <ChevronRight className="w-4 h-4 ml-1 group-hover:translate-x-1 transition-transform" />
                    </Button>
                  </Link>
                </CardContent>
              </Card>
            ))}
          </div>
        </section>
      </main>
      <Footer />
      <WhatsAppButton />
    </>
  );
};

export default BlogPage;
